angular.module('app')
    .controller('dettaglioContrattoCtrl', function ($scope) {
        
        $scope.initialize = function () {
            $scope.numero = localStorage.getItem("numeroContratto");
            $scope.modulo = localStorage.getItem("numeroModulo");
        }

        $scope.start = function () {

        }

       

    })